module.exports = __webpack_public_path__ + "img/IOST.e55e39cb.svg";